import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const CollectionPlaceholderIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 40 32"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path fill="#E4E4E4" d="m34 7-13 3L5 7l14-2 15 2Z" />
            <path fill="#D2D2D2" d="M21 28V10L5 7l1 16 15 5Z" />
            <path fill="#D9D9D9" d="m33 23-12 5V10l13-3-1 16Z" />
        </svg>
    </IconWrapper>
)
